import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaorecebimento(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaorecebimento/FIND_OPERACAORECEBIMENTO':
      case '@operacaorecebimento/UPDATE_OPERACAORECEBIMENTO':
      case '@operacaorecebimento/DELETE_OPERACAORECEBIMENTO':
      case '@operacaorecebimento/STORE_OPERACAORECEBIMENTO':
      case '@operacaorecebimento/OPERACAORECEBIMENTOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaorecebimento/SUCCESS_REMOVE':
      case '@operacaorecebimento/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaorecebimento/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaorecebimentos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaorecebimento/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaorecebimento;
        break;
      }

      case '@operacaorecebimento/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
